import { z } from 'zod/v4';

export const BulkUnarchiveFindingsRequestSchema = z.object({
  findingIds: z
    .array(z.string().min(1))
    .min(1, 'At least one finding ID is required'),
});

export type BulkUnarchiveFindingsRequest = z.infer<
  typeof BulkUnarchiveFindingsRequestSchema
>;
